/* unplugin-vue-components disabled */import { render } from "./expertAnswer.vue?vue&type=template&id=8f743252&scoped=true"
import script from "./expertAnswer.vue?vue&type=script&lang=js"
export * from "./expertAnswer.vue?vue&type=script&lang=js"

import "./expertAnswer.vue?vue&type=style&index=0&id=8f743252&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8f743252"]])

export default __exports__